import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';

export const StyledBox = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  gap: '16px',
  width: '100%',
  marginBottom: '21px',
}));

export const StyledHeaderWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '22px 22px 22px 86px',
  borderRadius: '18px',
  background: theme.palette.background.paper,
}));

export const StyledProgressWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  width: '80px',
  height: '80px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '18px',
  background: theme.palette.background.paper,
  margin: '0px',
}));
